var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { keys } from 'lodash';
import * as React from 'react';
import * as moment from 'moment';
import * as qs from 'query-string';
import { connect } from 'react-redux';
import { Query, Mutation } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import { VideoPlayerWithLoader, VideoPlayer } from 'src/components/reusable/VideoPlayer';
import styles from './VideoEmbedCodes.styles';
import { getTranslation } from 'src/translation';
import { getVideoDuration } from 'src/utils/cards';
import Animate from '../../../theme/components/Animate';
import { replaceTranslationSkipCharacters, replaceBreaks } from 'src/utils/common';
import { getVideoEmbed } from 'src/gql/getVideoEmbed';
import { addAnonymousAnalyticsMutation, addAnonymousAnalyticsVariables } from 'src/gql/addAnonymousAnalytics';
// const isDevStage =
//   window.location.href.indexOf('localhost') !== -1 ||
//   window.location.href.indexOf(':3000') !== -1 ||
//   window.location.href.indexOf('tt-react-dev') !== -1 ||
//   window.location.href.indexOf('tt-react-test') !== -1 ||
//   window.location.href.indexOf('.dev.trainingtube.com') !== -1
// @ts-ignore
var Embed = /** @class */ (function (_super) {
    __extends(Embed, _super);
    function Embed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Embed.prototype.componentDidMount = function () {
        // if (isDevStage) return
        // const scriptEl = document.createElement('script')
        // const noScriptEl = document.createElement('noscript')
        // const imgEl = document.createElement('img')
        // scriptEl.innerHTML = `
        //   !function(f,b,e,v,n,t,s)
        //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        //   n.queue=[];t=b.createElement(e);t.async=!0;
        //   t.src=v;s=b.getElementsByTagName(e)[0];
        //   s.parentNode.insertBefore(t,s)}(window, document,'script',
        //   'https://connect.facebook.net/en_US/fbevents.js');
        //   fbq('init', '432949744083181');
        //   fbq('track', 'PageView');
        // `
        // imgEl.src = 'https://www.facebook.com/tr?id=432949744083181&ev=PageView&noscript=1'
        // imgEl.height = 1
        // imgEl.width = 1
        // imgEl.hidden = true
        // noScriptEl.appendChild(imgEl)
        // document.body.appendChild(scriptEl)
        // document.body.appendChild(noScriptEl)
    };
    Embed.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, hasActiveSubscription = _a.hasActiveSubscription, logo = _a.logo;
        return (React.createElement(Query, __assign({}, getVideoEmbed(this.props.match.params.key, this.props.orgId)), function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading) {
                return React.createElement("p", null, _this.props.translate('loading'));
            }
            if (error) {
                // @ts-ignore
                var message = error.networkError.result ? error.networkError.result.message : error.message;
                return (React.createElement("div", { className: "flex flex-col flex-1 items-center justify-center p-16" },
                    React.createElement("div", { className: "max-w-512 text-center" },
                        React.createElement(Animate, { delay: 500 },
                            React.createElement(Typography, { variant: "headline", color: "textSecondary", className: "mb-16 capitalize" }, message)),
                        React.createElement(Animate, { delay: 600 },
                            React.createElement(Typography, { variant: "subheading", color: "textSecondary", className: "mb-48" }, _this.props.translate('video-not-found'))))));
            }
            var _b = data.getFromEmbedRes, abstract = _b.abstract, createdAt = _b.createdAt, description = _b.description, name = _b.name, duration = _b.duration, type = _b.type, renderingData = _b.renderingData;
            var subtitles = keys(renderingData || {}).reduce(function (r, lang) {
                if (!renderingData[lang].subtitles)
                    return r;
                return __spreadArray(__spreadArray([], r), [
                    {
                        language: lang,
                        chapters: renderingData[lang].subtitles.map(function (data) { return (__assign(__assign({}, data), { manuscript: replaceBreaks(replaceTranslationSkipCharacters(data.manuscript)) })); }),
                    },
                ]);
            }, []);
            var videoDuration = duration ? getVideoDuration(duration / 1000) : null;
            var createdAtDate = moment(new Date(createdAt)).format('MMMM Do, YYYY');
            var isIframe = _this.props.match.path === '/sharing/embed/:key';
            var parsedQuerySting = qs.parse(location.search);
            var subTitleLang = parsedQuerySting && parsedQuerySting.subTitleLang;
            return data.getFromEmbedRes.publicEmbed ? (React.createElement(Mutation, __assign({}, addAnonymousAnalyticsMutation(_this.props.orgId)), function (addAnonymousAnalyticsReq) {
                if (loading) {
                    return React.createElement("p", null, _this.props.translate('loading'));
                }
                if (error) {
                    return React.createElement("p", null, error.message);
                }
                return (React.createElement(React.Fragment, null, isIframe ? (React.createElement("div", null,
                    React.createElement(VideoPlayer, { source: data.getFromEmbedRes.url, videoDuration: videoDuration, ribbonType: type, tubeColor: 'rgb(0,0,0,0.8)', showTTLogo: isIframe, isEmbedVideo: true, thumbnail: data.getFromEmbedRes.thumbnail, subtitlesLang: subTitleLang || data.getFromEmbedRes.language, onPlaybackEvent: function (event, time) {
                            addAnonymousAnalyticsReq(addAnonymousAnalyticsVariables({
                                type: event,
                                payload: event === 'videoTimeWatched'
                                    ? {
                                        videoId: data.getFromEmbedRes.videoId,
                                        time: time,
                                        version: data.getFromEmbedRes.lastVersion,
                                        lang: data.getFromEmbedRes.language,
                                    }
                                    : {
                                        videoId: data.getFromEmbedRes.videoId,
                                        version: data.getFromEmbedRes.lastVersion,
                                        lang: data.getFromEmbedRes.language,
                                    },
                            }));
                        }, voiceOver: subtitles }))) : (React.createElement("div", { className: classes.bodyWrapper },
                    React.createElement("div", { className: classes.headerWrapper },
                        React.createElement("img", { onClick: function () {
                                return !hasActiveSubscription && (window.location.href = 'https://www.launchpeople.com/');
                            }, className: classes.logoImg, style: hasActiveSubscription ? { cursor: 'default' } : {}, src: hasActiveSubscription ? logo : '/assets/images/logos/training-tube.png' }),
                        !hasActiveSubscription ? (React.createElement(Button, { style: { backgroundColor: '#A6419A' }, onClick: function () {
                                window.location.href = 'https://www.trainingtube.com/booking-a-demo';
                            }, className: classes.trainingTubeRedirect }, _this.props.translate('get-training-tube'))) : (React.createElement(Button, { style: { backgroundColor: '#A6419A' }, onClick: function () {
                                window.location.href = "https://www.trainingtube.com/login?redirectTo=/&commingFrom=" + _this.props.orgId;
                            }, className: classes.trainingTubeRedirect }, _this.props.translate('login')))),
                    React.createElement("div", { className: classes.cardWrapper },
                        React.createElement("div", { className: classes.innerCard },
                            React.createElement("div", { className: classes.videoWrapper },
                                React.createElement(VideoPlayer, { isEmbedVideo: true, subtitlesLang: subTitleLang || data.getFromEmbedRes.language, source: data.getFromEmbedRes.url, videoDuration: videoDuration, ribbonType: type, tubeColor: 'rgb(0,0,0,0.8)', thumbnail: data.getFromEmbedRes.thumbnail, onPlaybackEvent: function (event, time) {
                                        addAnonymousAnalyticsReq(addAnonymousAnalyticsVariables({
                                            type: event,
                                            payload: event === 'videoTimeWatched'
                                                ? {
                                                    videoId: data.getFromEmbedRes.videoId,
                                                    time: time,
                                                    version: data.getFromEmbedRes.lastVersion,
                                                    lang: data.getFromEmbedRes.language,
                                                }
                                                : {
                                                    videoId: data.getFromEmbedRes.videoId,
                                                    version: data.getFromEmbedRes.lastVersion,
                                                    lang: data.getFromEmbedRes.language,
                                                },
                                        }));
                                    }, voiceOver: subtitles })),
                            React.createElement("div", { className: classes.videoName }, replaceTranslationSkipCharacters(name)),
                            React.createElement("div", { className: classes.videoAbstract }, replaceTranslationSkipCharacters(abstract)),
                            React.createElement("div", { className: classes.imageContainer },
                                React.createElement("div", { className: classes.videoCreatedDate },
                                    React.createElement("div", null, createdAtDate))),
                            description !== '<p><br></p>' && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: classes.descriptionTitle }, _this.props.translate('description')),
                                React.createElement("div", { className: classes.descriptionBody, dangerouslySetInnerHTML: {
                                        __html: replaceTranslationSkipCharacters(description),
                                    } })))))))));
            })) : (React.createElement(VideoPlayerWithLoader, { isEmbedVideo: true, subtitlesLang: subTitleLang || data.getFromEmbedRes.language, lang: data.getFromEmbedRes.language, masterLanguage: data.getFromEmbedRes.masterLanguage, videoId: data.getFromEmbedRes.videoId, lastVersion: data.getFromEmbedRes.lastVersion, source: data.getFromEmbedRes.url, thumbnail: data.getFromEmbedRes.thumbnail, subtitles: subtitles }));
            // return data.getFromEmbedRes.publicEmbed ? (
            //   <VideoPlayer source={data.getFromEmbedRes.url} thumbnail={data.getFromEmbedRes.thumnail} onPlaybackEvent={(event, time) => {}} />
            // ) : (
            //   <VideoPlayerWithLoader
            //     lang={data.getFromEmbedRes.language}
            //     masterLanguage={data.getFromEmbedRes.masterLanguage}
            //     videoId={data.getFromEmbedRes.videoId}
            //     lastVersion={data.getFromEmbedRes.lastVersion}
            //     source={data.getFromEmbedRes.url}
            //     thumbnail={data.getFromEmbedRes.thumnail}
            //   />
            // )
        }));
    };
    Embed = __decorate([
        withStyles(styles),
        connect(function (state, ownProps) {
            return __assign(__assign({}, ownProps), { orgId: state.auth.organization.id || state.auth.user.data.organization.id, translate: getTranslation(state.translation.lang), hasActiveSubscription: state.auth.organization.hasActiveSubscription, logo: state.auth.organization.logo, tubeColor: state.auth.tube.color });
        })
    ], Embed);
    return Embed;
}(React.Component));
export { Embed };



//////////////////
// WEBPACK FOOTER
// ./src/components/routes/embed/index.tsx
// module id = 1621
// module chunks = 81